<template>
  <div>
    <el-card>
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="待审核" name="first"> </el-tab-pane>
        <el-tab-pane label="已审核" name="second"> </el-tab-pane>
        <div class="btn-group">
          <div class="rowpart">
            <!-- 科室 -->
            <el-input v-model="departmentName" :disabled="true"></el-input>
          </div>
          <!-- 年份选择 -->
          <div class="rowpart">
            <el-date-picker
              style="width: 120px"
              v-model="year"
              type="year"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>

          <!-- 季度选择 -->
          <SeasonSelect
            class="rowpart"
            @season="this.season = $event"
          ></SeasonSelect>
        </div>

        <div>
          <el-table
            :data="tableData1"
            border
            style="width: 100%"
            height="600"
            ref="table1"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: 'taskId' }"
          >
            <el-table-column type="selection" width="55" fixed />
            <template v-for="column in reportReviewTable" :key="column.label">
              <el-table-column
                :prop="column.prop"
                :label="column.label"
                width="180"
                sortable
              >
              </el-table-column>
            </template>
            <el-table-column label="操作" width="160" fixed="right">
              <template #default="scope">
                <el-button
                  v-if="activeTab == 'first'"
                  type="text"
                  size="mini"
                  @click="handleReview(scope.$index, scope.row)"
                  >审核</el-button
                >
                <el-button
                  v-else
                  type="text"
                  size="mini"
                  @click="handleOpen(scope.$index, scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tabs>
    </el-card>

    <el-dialog
      v-model="showableComp.reviewDialog"
      width="80%"
      title="工作报告审批"
    >
      <div>
        <h2>{{ dialogData.title }}</h2>
        <p>{{ dialogData.date }}</p>
        <el-form :disabled="disableComp.dialogForm">
          <el-collapse v-model="activeCollapse">
            <el-collapse-item title="阶段性目标任务和临时交办任务" name="1">
              <el-input
                type="textarea"
                rows="8"
                v-model="dialogData.tasks"
              ></el-input>
            </el-collapse-item>
            <el-collapse-item title="考核周期工作小结" name="2">
              <el-input
                type="textarea"
                rows="8"
                v-model="dialogData.summary"
              ></el-input>
            </el-collapse-item>

            <el-collapse-item title="附件" name="3">
              <div class="appendix-group">
                <template v-for="item in dialogData.appendix" :key="item.url">
                  <div class="appendix">
                    <el-button
                      type="text"
                      size="small"
                      @click="downloadFile(item.url)"
                      >{{ item.name }}</el-button
                    >
                  </div>
                </template>
              </div>
            </el-collapse-item>
            <el-collapse-item class="select-btn" title="领导评价" name="4">
              <DeductScoreSelect
                @score="this.dialogData.score = $event"
              ></DeductScoreSelect>
            </el-collapse-item>

            <el-collapse-item title="审核意见" name="5">
              <div>
                <el-input
                  type="textarea"
                  rows="8"
                  v-model="dialogData.comments"
                ></el-input>
              </div>
            </el-collapse-item>
          </el-collapse>

          <div class="btn-bottom">
            <el-button type="success" @click="passReport">通过</el-button>
            <el-button type="danger" @click="rejectReport">驳回</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reportReviewTable } from "../data/ReportReview";
import SeasonSelect from "@/components/SeasonSelect.vue";
import DeductScoreSelect from "@/components/DeductScoreSelect.vue";

export default {
  data() {
    return {
      activeTab: "first",
      departmentName: "城市建设科",
      season: "",
      year: "",
      reportReviewTable: [],
      showableComp: {
        reviewDialog: false,
      },
      disableComp: {
        dialogForm: false,
      },
      tableData1: [
        {
          reportID: "100",
          userName: "张三",
          detail: "阿斯顿金卡是看见好卡",
        },
      ],
      dialogData: {
        date: "2022-01-01",
        title: "XX报告",
        tasks: "",
        summary: "",
        appendix: [
          {
            name: "第一个",
            url: "url1",
          },
          {
            name: "第二个",
            url: "url2",
          },
        ],
        comments: "",
        state: "",
        score: "",
      },
      activeCollapse: ["1", "2", "3", "4", "5"],
    };
  },
  name: "ReportReview",
  methods: {
    //   审批
    handleReview() {
      this.showableComp.reviewDialog = true;
      this.disableComp.dialogForm = false;
    },
    // 查看
    handleOpen() {
      this.showableComp.reviewDialog = true;
      this.disableComp.dialogForm = true;
    },
    downloadFile(fileURL) {
      console.log(fileURL);
    },

    // 通过审批
    passReport() {
      console.log("通过");
    },
    rejectReport() {
      console.log("驳回");
    },
  },
  components: { SeasonSelect, DeductScoreSelect },
  created() {
    this.reportReviewTable = reportReviewTable;
  },
};
</script>



<style scoped lang="scss">
.btn-group {
  display: flex;
  justify-content: start;
  margin-bottom: 20px;
}

.rowpart {
  margin-right: 10px;
  width: 120px;
}

.sub-title {
  text-align: left;
}

.appendix {
  display: flex;
  justify-content: start;
}

.btn-bottom {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

.select-btn {
  text-align: start;
}
</style>